import { useAuth } from 'modules/auth/hooks/useAuth';

import { useAssociatedAccounts } from './useAssociatedAccounts';
import { useUserETHAddresses } from './useUserETHAddresses';

export const useInitUser = () => {
  const { isLoggedIn } = useAuth();

  useUserETHAddresses({ skipFetching: !isLoggedIn });

  useAssociatedAccounts({ skipFetching: !isLoggedIn });
};
